import styled from 'styled-components';
import breakpoints from '../../theme/constants/breakpoints';
import zIndex from '../../theme/constants/zIndex';
import {StyledContainerProps} from './typings';
import colors from '../../theme/constants/colors';

export const StyledMobileFilters = styled.div`
  display: block;

  @media only screen and ${breakpoints.device.m} {
    display: none;
  }
`;

export const StyledTabletFilters = styled.div`
  display: none;

  @media only screen and ${breakpoints.device.m} {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 60px;

    & > *:not(:first-child) {
      margin-left: 10px;
    }
  }
`;

export const StyledContainer = styled.div<StyledContainerProps>`
  background: ${colors.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  position: sticky;
  top: 0;
  z-index: ${(props) =>
    props.$mobileOpen === true ? 10000 : zIndex.sticky}; // TODO: remove after navigation is fixed

  & > *:last-child {
    margin-left: auto;
  }

  @media only screen and ${breakpoints.device.s} {
    top: 74px;
  }

  @media only screen and ${breakpoints.device.m} {
    z-index: ${zIndex.sticky};
  }

  @media only screen and ${breakpoints.device.l} {
    top: 117px;
  }
`;
